exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-package-selector {\n  width: 100%;\n  min-width: 200px;\n}\n", ""]);

// exports
